<template>
  <div>
    <vm-table
        ref="vmTable"
        module="basic"
        max-height="200px"
        :is-height="false"
        :columns-btn-show="false"
        :url="'productionManage/listSN?id=' + pkid">
      <el-table-column align="center" label="产品序列号" width="200">
        <template slot-scope="scope">
          <span>{{scope.row}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="物料编号" width="150">
        <template>
          <span>{{orderInfo.materialNo}}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="物料名称" min-width="400">
        <template>
          <span>{{orderInfo.materialName}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="80" prop="action">
        <template slot-scope="scope">
          <el-button type="primary" @click="printCode(scope.row)">打印</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <material-code-modal ref="materialCodeModal"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import MaterialCodeModal from "./MaterialCodeModal";

  export default {
    components: {
      VmTable,
      MaterialCodeModal,
    },
    props: {
      pkid: {
        type: Number,
      },
      orderInfo: {
        type: Object,
      },
    },
    watch: {
      pkid: {
        handler(newval) {
          this.pkid = newval;
          this.$nextTick(() => {
            this.$refs.vmTable.getList(1);
          });
        },
        immediate: true,
      },
    },

    methods: {
      printCode(row) {
        const arr = [
          {
            itemSn: row,
          },
        ];
        this.$refs.materialCodeModal.open(arr, this.orderInfo);
      },
    },
  };
</script>
